export const JsonLdSchemaHeader = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': ['Organization', 'FinancialService'],
      '@id': 'https://www.sravni.ru/#organization',
      name: 'Сравни',
      alternateName: 'Сравни.ру',
      legalName: 'ООО «Сравни.ру»',
      url: 'https://www.sravni.ru',
      logo: {
        '@type': 'ImageObject',
        url: 'https://s91588.cdn.ngenix.net/shared/static/apple-touch-icon-114x114.png',
        width: 114,
        height: 114,
      },
      contactPoint: [
        {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          areaServed: 'RU',
          availableLanguage: 'Russian',
          email: 'pr@sravni.ru',
          telephone: '8007073902',
        },
      ],
      foundingDate: '2009-05-09',
      description:
        'Российский финансовый маркетплейс для подбора займов, кредитов, вкладов, ипотеки, страховых и банковских продуктов для физических и юридических лиц.',
      subOrganization: { '@id': 'https://sravni.market/#organization' },
      areaServed: {
        '@type': 'Country',
        name: 'Россия',
        sameAs: 'https://www.wikidata.org/wiki/Q159',
      },
      sameAs: [
        'https://ru.wikipedia.org/wiki/%D0%A1%D1%80%D0%B0%D0%B2%D0%BD%D0%B8.%D1%80%D1%83',
        'https://www.wikidata.org/wiki/Q4438348',
        'https://dzen.ru/sravni.ru',
        'https://ok.ru/sravni',
        'https://vk.com/sravni',
        'https://t.me/sravni_tg',
      ],
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Moscow',
        streetAddress: 'бульвар Энтузиастов, дом 2, 26 этаж',
        postalCode: '109544',
        addressCountry: 'RU',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Финансовые продукты Сравни',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'LoanOrCredit',
              name: 'Кредиты',
              description: 'Подбор и сравнение потребительских кредитов наличными от банков России',
              url: 'https://www.sravni.ru/kredity/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'LoanOrCredit',
              name: 'Займы',
              description: 'Подбор и сравнение займов микрофинансовых организаций',
              url: 'https://www.sravni.ru/zaimy/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'LoanOrCredit',
              name: 'Ипотека',
              description: 'Подбор и сравнение ипотечных кредитов, семейная ипотека, рефинансирование',
              url: 'https://www.sravni.ru/ipoteka/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'LoanOrCredit',
              name: 'Автокредиты',
              description: 'Подбор и сравнение автокредитов',
              url: 'https://www.sravni.ru/avtokredity/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'PaymentCard',
              name: 'Кредитные карты',
              description: 'Подбор и сравнение кредитных карт банков России',
              url: 'https://www.sravni.ru/karty/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'PaymentCard',
              name: 'Дебетовые карты',
              description: 'Подбор и сравнение дебетовых карт банков России',
              url: 'https://www.sravni.ru/debetovye-karty/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'BankAccount',
              name: 'Вклады',
              description: 'Подбор и сравнение вкладов и депозитов банков России',
              url: 'https://www.sravni.ru/vklady/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'BankAccount',
              name: 'Накопительные счета',
              description: 'Подбор и сравнение накопительных счетов банков России',
              url: 'https://www.sravni.ru/vklady/nakopitelnye/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'InvestmentOrDeposit',
              name: 'Брокерское обслуживание',
              description: 'Подбор и сравнение лицензированных брокеров для инвестиций',
              url: 'https://www.sravni.ru/invest/brokerskoe-obsluzhivanie/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'InvestmentOrDeposit',
              name: 'Программы долгосрочных сбережений',
              description: 'Подбор и сравнение программ долгосрочных сбережений граждан',
              url: 'https://www.sravni.ru/invest/pds-programmy/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'InvestmentOrDeposit',
              name: 'Пенсионные программы',
              description: 'Подбор и сравнение пенсионных программ',
              url: 'https://www.sravni.ru/invest/npf-programmy/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'InvestmentOrDeposit',
              name: 'Инвестиции в бизнес',
              description: 'Подбор и сравнение инвестиционных программ',
              url: 'https://www.sravni.ru/invest/investicii-v-biznes/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'ОСАГО',
              description: 'Сравнение и онлайн-оформление полисов ОСАГО',
              url: 'https://www.sravni.ru/osago/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Каско',
              description: 'Сравнение и оформление полисов каско',
              url: 'https://www.sravni.ru/kasko/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Страхование ипотеки',
              description: 'Оформление страховки для ипотечных заёмщиков',
              url: 'https://www.sravni.ru/strahovanie-ipoteki/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Страхование путешественников',
              description: 'Страхование для путешествий по России и за рубежом',
              url: 'https://www.sravni.ru/vzr/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Добровольное медицинское страхование',
              description: 'Подбор полисов ДМС для физических лиц',
              url: 'https://www.sravni.ru/dms/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Страхование жилья',
              description: 'Страхование квартиры, дома и дачи',
              url: 'https://www.sravni.ru/strahovanie-nedvizhimosti/kvartiry/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Спортивное страхование',
              description: 'Страхование при занятии спортом',
              url: 'https://www.sravni.ru/strahovanie-ns/sportivnaya/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Страхование домашних животных',
              description: 'Подбор полисов страхования домашних животных',
              url: 'https://www.sravni.ru/strahovanie-zhivotnih/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Расчётно-кассовое обслуживание бизнеса',
              description: 'Подбор тарифов расчётно-кассового обслуживания для бизнеса',
              url: 'https://www.sravni.ru/rko/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Кредиты для бизнеса',
              description: 'Подбор кредитов для бизнеса',
              url: 'https://www.sravni.ru/biznes-kredity/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Лизинг для юридических лиц',
              description: 'Подбор предложений лизинга для бизнеса',
              url: 'https://www.sravni.ru/biznes-leasing/marketplace/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Эквайринг',
              description: 'Подбор тарифов по эквайрингу',
              url: 'https://www.sravni.ru/biznes/ekvajring/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'FinancialProduct',
              name: 'Бухгалтерские услуги',
              description: 'Подбор специалистов по ведению бухучета',
              url: 'https://www.sravni.ru/biznes-accounting/',
            },
          },
        ],
      },
    },
    {
      '@type': ['Organization', 'FinancialService'],
      '@id': 'https://sravni.market/#organization',
      name: 'Сравни Маркет',
      alternateName: 'Сравни.Маркет',
      url: 'https://sravni.market',
      logo: {
        '@type': 'ImageObject',
        url: 'https://s91588.cdn.ngenix.net/shared/static/apple-touch-icon-114x114.png',
        width: 114,
        height: 114,
      },
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '88006008135',
          contactType: 'customer service',
          areaServed: 'RU',
          availableLanguage: 'Russian',
          email: 'service@sravni.market',
        },
      ],
      legalName: 'АО «Финансовый Маркетплейс Сравни.ру»',
      description:
        'Лицензированная финансовая платформа Сравни. В августе 2021 года первой из ИТ-компаний получила лицензию оператора финансовой платформы Банка России.',
      parentOrganization: { '@id': 'https://www.sravni.ru/#organization' },
      areaServed: {
        '@type': 'Country',
        name: 'Россия',
        sameAs: 'https://www.wikidata.org/wiki/Q159',
      },
      memberOf: {
        '@type': 'Project',
        name: 'Проект финансового маркетплейса Банка России',
        url: 'https://www.cbr.ru/fintech/market_place/',
        sameAs: 'https://ru.wikipedia.org/wiki/Маркетплейс_(проект_Банка_России)',
        parentOrganization: {
          '@type': 'GovernmentOrganization',
          name: 'Банк России',
          alternateName: 'ЦБ РФ',
          url: 'https://www.cbr.ru',
          sameAs: ['https://ru.wikipedia.org/wiki/Банк_России', 'https://www.wikidata.org/wiki/Q168278'],
        },
      },
      subjectOf: { '@id': 'https://sravni.market/#permit' },
      hasCredential: {
        '@type': 'EducationalOccupationalCredential',
        name: 'Лицензия оператора финансовой платформы',
        credentialCategory: 'Оператор финансовой платформы',
        dateCreated: '2021-08-01',
        description:
          'Зарегистрирована Банком России. Документ о регистрации АО «Финансовый Маркетплейс Сравни.ру» опубликован на официальном сайте Банка России. Первая ИТ-компания с данным статусом.',
        url: 'https://cbr.ru/rbr/rbr_fr/doc?id=47850',
        recognizedBy: {
          '@type': 'GovernmentOrganization',
          name: 'Банк России',
          alternateName: 'ЦБ РФ',
          url: 'https://www.cbr.ru',
          sameAs: [
            'https://ru.wikipedia.org/wiki/%D0%91%D0%B0%D0%BD%D0%BA_%D0%A0%D0%BE%D1%81%D1%81%D0%B8%D0%B8',
            'https://www.wikidata.org/wiki/Q168278',
          ],
        },
      },
    },
    {
      '@id': 'https://sravni.market/#permit',
      '@type': 'GovernmentPermit',
      name: 'Лицензия оператора финансовой платформы',
      description:
        'Зарегистрирована Банком России. Документ о регистрации АО «Финансовый Маркетплейс Сравни.ру» опубликован на официальном сайте Банка России. Первая ИТ-компания с данным статусом.',
      url: 'https://cbr.ru/rbr/rbr_fr/doc?id=47850',
      validFrom: '2021-08-01',
      issuedBy: {
        '@type': 'GovernmentOrganization',
        name: 'Банк России',
        alternateName: 'ЦБ РФ',
        url: 'https://www.cbr.ru',
        sameAs: ['https://ru.wikipedia.org/wiki/Банк_России', 'https://www.wikidata.org/wiki/Q168278'],
      },
      owner: { '@id': 'https://sravni.market/#organization' },
    },
  ],
};

export const JsonLdSchemaWebsite = {
  '@type': 'WebSite',
  '@id': 'https://www.sravni.ru/#website',
  url: 'https://www.sravni.ru/',
  name: 'Сравни.ру',
  publisher: { '@id': 'https://www.sravni.ru/#organization' },
};
